//@ts-check
import validateField from './fieldValidator';
import helper from './helper';
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {string} pageId
 * @return {Array<{fieldId:string, error: string}>}
 */

var validatePage = function validatePage(state, pageId) {
  var invalidFields = [];
  var pageLayout = state.layout.containers[pageId];
  if (!pageLayout) return invalidFields;
  var pageError = '';
  var fields = helper.findVisibleFields(pageLayout, state);
  fields.forEach(function (fieldId) {
    var error = validateField(fieldId, state);
    if (error) invalidFields.push({
      fieldId: fieldId,
      error: error
    });
    pageError = pageError || error;
  });
  if (pageError) invalidFields.push({
    fieldId: pageId,
    error: pageError
  });
  return invalidFields;
};

export default validatePage;